import moment from 'moment';
import R from 'ramda';

// ISODate :: String
// @link: https://en.wikipedia.org/wiki/ISO_8601

// YYYY-MM-DDThh:mm:ss.sssZ :: "2017-08-16T19:49:50.940Z"
// YYYY-MM-DD               :: "2017-08-16"

// isDayBetween :: ISODate|String, ISODate|String -> ISODate|String -> Bool
const isDayBetween = (startBoundary, endBoundary, day) =>
  moment(day)
    .startOf('day')
    .isBetween(
      moment(startBoundary).startOf('day'),
      moment(endBoundary).startOf('day'),
      null,
      '[]',
    );

export default R.curryN(2, isDayBetween);
